<app-common-form-container
  header="EmailAlerts.AlarmsAddEmailForm.Header"
  [formGroup]="formGroup"
  [showActionControls]="false"
  [useParentForm]="false"
>
  <form form-content [formGroup]="formGroup" class="user-select-form">
    <div fxLayout="row">
      <div class="d-flex flex-row col-md-6" style="align-items: center">
        <app-user-group-search-select
          class="w-3/4 px-4"
          [formGroup]="addAsUserOrGroupFormGroup"
          [orgId]="orgId"
          [restrictToOrganization]="true"
          fieldControlName="selectUserOrGroup"
          [placeholder]="'EmailAlerts.AlarmsForm.SelectUserOrGroup' | translate"
          [exclude]="isUserOrGroupAlreadyAdded"
          [disabled]="disabled"
          (userSelected)="onUserOrGroupPicked($event)"
        ></app-user-group-search-select>
        <div
          class="d-flex flex-column col-md-3"
          siteUsageTracker
          [logCategory]="'EmailAlerts.Alarms'"
          [logName]="'AddAlarmByUserOrGroup'"
          (click)="onAddAlertByUserOrGroup(userOrGroupSelectFormControl)"
        >
          <ng-container
            *ngTemplateOutlet="
              addAlarmsButton;
              context: { enable: disableAddUserByUserOrGroupBtn }
            "
          ></ng-container>
        </div>
      </div>

      <div class="d-flex flex-row col-md-6" style="align-items: center">
        <app-form-field
          fieldLabel="EmailAlerts.AlarmsForm.UserOrGroupLookupLabel"
          fieldControlName="existingEmail"
          [formGroup]="addAsEmailFormGroup"
          [placeholder]="'EmailAlerts.AlarmsForm.EmailAddressInputPlaceholder'"
          [validatorOrOpts]="[emailValidator, alreadyExistsInListValidator]"
          type="email"
          col="9"
        >
        </app-form-field>
        <div
          class="d-flex flex-column col-md-3"
          siteUsageTracker
          [logCategory]="'EmailAlerts.Alarms'"
          [logName]="'AddAlarmByEmail'"
          (click)="onAddAlertByEmail(existingEmailFormControl)"
        >
          <ng-container
            *ngTemplateOutlet="
              addAlarmsButton;
              context: { enable: disableAddUserByEmailBtn }
            "
          ></ng-container>
        </div>
      </div>
    </div>
  </form>
</app-common-form-container>

<app-common-form-container
  header="EmailAlerts.AlarmsListEmailForm.Header"
  [formGroup]="formGroup"
  (saveClick)="onSaveClick()"
  (resetClick)="onResetClick()"
  [useParentForm]="false"
  [saveButtonText]="'EmailAlerts.Button.Save'"
  >
  <form form-content>
    <ng-container *ngIf="formLoaded === true; else formLoading">
      <div
        fxLayout="row"
        [formGroup]="formGroup"
        class="inactive-email-alert-toggle"
      >
        <app-form-field
          fieldLabel="EmailAlerts.AlarmsForm.IncludeInactiveEmailAlertsDefinitionLabel"
          fieldControlName="inactiveEmailAlertDefinitionToggle"
          type="checkbox"
          [formGroup]="inactiveEmailAlertDefinitionToggle"
          [formState]="false"
          (valueChanged)="onFilterInactiveChange($event)"
          col="9"
        >
        </app-form-field>
      </div>
      <div fxLayout="column" [formGroup]="formGroup">
        <div fxLayout="column" formArrayName="userAlarmDefintions">
          <ng-container
            *ngIf="emailAlertFormItems?.length > 0; else noAlertsFound"
          >
            <ng-container
              *ngFor="
                let userAlarmDefinition of emailAlertFormItems;
                let i = index;
                trackBy: trackByFn
              "
              [formGroupName]="i"
            >
              <div
                class="email-alert-definition-item"
                [hidden]="!userAlarmDefinition?.active && !filterInactive"
              >
                <div class="email-alert-definition-options-row">
                  <!-- hidden fields -->
                  <app-form-field
                    fieldControlName="alarmID"
                    [formGroup]="userAlarmDefintionsFormArray.at(i)"
                    [formState]="userAlarmDefinition?.alarmID"
                    type="hidden"
                    col="0"
                  >
                  </app-form-field>
                  <app-form-field
                    fieldControlName="userId"
                    [formGroup]="userAlarmDefintionsFormArray.at(i)"
                    [formState]="userAlarmDefinition?.userId"
                    type="hidden"
                    col="0"
                  >
                  </app-form-field>
                  <app-form-field
                    fieldControlName="entityId"
                    [formGroup]="userAlarmDefintionsFormArray.at(i)"
                    [formState]="userAlarmDefinition?.entityId"
                    type="hidden"
                    col="0"
                    ></app-form-field>
                  <app-form-field
                    fieldControlName="emailAddress"
                    [formGroup]="userAlarmDefintionsFormArray.at(i)"
                    [formState]="userAlarmDefinition?.emailAddress"
                    type="hidden"
                    col="0"
                  >
                  </app-form-field>

                  <!-- Input fields -->
                  <app-form-field
                    fieldLabel="EmailAlerts.AlarmsForm.AlarmDescription"
                    fieldControlName="alarmDefinitionName"
                    [formGroup]="userAlarmDefintionsFormArray.at(i)"
                    [formState]="userAlarmDefinition?.alarmDefinitionName"
                    [validatorOrOpts]="[Validators.maxLength(200)]"
                    type="input"
                    col="3"
                  >
                  </app-form-field>

                  <app-form-field
                    fieldLabel="EmailAlerts.AlarmsForm.User"
                    [labelValue]="getUserNameOrEmail(userAlarmDefinition)"
                    type="label"
                    col="2"
                  >
                  </app-form-field>

                  <app-form-field
                    fieldLabel="EmailAlerts.AlarmsForm.type"
                    fieldControlName="alarmTypeName"
                    [labelValue]="userAlarmDefinition?.alarmTypeName"
                    type="label"
                    col="2"
                  >
                  </app-form-field>

                  <app-form-field
                    [formGroup]="userAlarmDefintionsFormArray.at(i)"
                    fieldLabel="EmailAlerts.AlarmsForm.notificationType"
                    fieldControlName="notificationType"
                    type="radio-group"
                    [formState]="userAlarmDefinition?.notificationType"
                    [options]="[
                      { text: 'EmailAlerts.AlarmsForm.Normal', value: 1 }
                    ]"
                    col="2"
                  >
                  </app-form-field>
                </div>
                <div
                  class="email-alert-definition-options-row"
                  formArrayName="alarmOptions"
                >
                  <ng-container
                    *ngFor="
                      let alarmOption of userAlarmDefinition?.alarmOptions;
                      let ii = index;
                      trackBy: trackAlarmByFn
                    "
                    [formGroupName]="ii"
                  >
                    <app-form-field
                      fieldLabel="{{
                        'EmailAlerts.AlarmsForm.' + alarmOption.alarmName
                      }}"
                      fieldControlName="{{ alarmOption?.alarmName }}"
                      [formGroup]="
                        userAlarmDefintionsFormArray
                          .at(i)
                          .get('alarmOptions')
                          .at(ii)
                      "
                      type="checkbox"
                      [formState]="alarmOption?.isSelected"
                      col="3"
                    >
                    </app-form-field>
                  </ng-container>
                </div>

                <div
                  class="undo-add-button-container"
                  matRipple
                  *ngIf="userAlarmDefinition.alarmID === 0"
                  siteUsageTracker
                  [logCategory]="'EmailAlerts.Alarms'"
                  [logName]="'UndoAddAlarm'"
                  (click)="undoAddNewItem(i)"
                  mat-icon-button
                >
                  <mat-icon style="width: 25px; height: 25px">undo</mat-icon>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </form>
</app-common-form-container>

<!-- common templates -->
<ng-template #noAlertsFound>
  <div class="no-alerts-found">
    <p>{{ 'EmailAlerts.AlarmsListEmailForm.NoAlertsFound' | translate }}</p>
  </div>
</ng-template>
<ng-template #formLoading>
  <div
    class="loading-container"
    fxFlexLayout="row"
    fxLayoutAlign="center center"
  >
    <mat-spinner></mat-spinner>
  </div>
</ng-template>

<ng-template #addAlarmsButton let-item="enable">
  <div class="add-alarms-button">
    <button mat-button [disabled]="item">
      <mat-icon class="mat-18">add</mat-icon
      >{{ 'EmailAlerts.AlarmsAddEmailForm.AddAlarm' | translate }}
    </button>
  </div>
</ng-template>

<section *ngIf="false" style="background-color: black">
  <pre style="color: greenyellow">
  disabled: {{ formGroup.disabled }}
  dirty: {{ formGroup.dirty }}
  status: {{ formGroup.status }}
  value: {{ formGroup.value | json }}
  pristine: {{ formGroup.pristine }}
  touched: {{ formGroup.touched }}
    </pre
  >
</section>
